import { Permission } from '@instamenu/data-access';

export const permissions: Record<string, string[]> = {
  '/sales-summary': [Permission.Reporting],
  '/customers': [Permission.Reporting],
  '/ai': [Permission.Reporting],
  '/employees': [Permission.Reporting],
  '/scheduled-orders': [Permission.Reporting],
  '/shifts': [Permission.Reporting],
  '/invoices': [Permission.Reporting],
  '/payouts': [Permission.Reporting],
  '/payouts/create': [Permission.AccountManagement],
  '/gift-cards': [Permission.Reporting],
  '/loyalty': [Permission.Reporting],
  '/settings': [Permission.Reporting],
  '/orders/[id]': [Permission.Reporting, Permission.ReactionRecipient],
  '/orders/[id]/refund': [Permission.Reporting],
  '/preferences': [],
};
